import { ITenantDetails } from "../@types/Login";
import {
  AUTH_API_BASE_URL,
  AUTH_TENANT_DETAILS,
} from "../constants/localStorageKeys";
import { safeJsonParse, safeStorage } from "./storage";

/**
 * Returns the region this session operates on ("EU" / "US"), used by the
 * /admin environment banner (EN-5129). SuperAdmins hold separate credentials
 * per region, so the session region is fixed at login:
 * - primary source: the login response's tenantDetails.region;
 * - fallback: which regional API base URL login selected (see
 *   setApiBaseUrlForRegion in services/api.ts);
 * - defaults to "EU", the platform's primary region, when neither is stored
 *   (pre-region sessions).
 */
export function getCurrentRegion(): "EU" | "US" {
  const tenantDetails = safeJsonParse<ITenantDetails | null>(
    safeStorage.getItem(AUTH_TENANT_DETAILS),
    null
  );

  const region = tenantDetails?.region?.toUpperCase();
  if (region === "US" || region === "EU") return region;

  const baseUrl = safeStorage.getItem(AUTH_API_BASE_URL);
  if (
    baseUrl &&
    process.env.REACT_APP_US_API_URL &&
    baseUrl === process.env.REACT_APP_US_API_URL
  ) {
    return "US";
  }

  return "EU";
}
